import React from 'react'
import { FaHeartbeat } from 'react-icons/fa'

export default function Loading({ 
    variant = 'default', 
    size = 'medium', 
    message = '', 
    fullScreen = false,
    className = '' 
}) {
    // Size configurations
    const sizeConfig = {
        small: {
            spinner: 'h-8 w-8',
            container: 'p-2',
            text: 'text-xs',
            heartbeat: 'text-lg'
        },
        medium: {
            spinner: 'h-16 w-16',
            container: 'p-4',
            text: 'text-sm',
            heartbeat: 'text-2xl'
        },
        large: {
            spinner: 'h-24 w-24',
            container: 'p-6',
            text: 'text-base',
            heartbeat: 'text-3xl'
        }
    };

    const config = sizeConfig[size];

    // Variant configurations
    const variants = {
        default: (
            <div className={`animate-spin rounded-full ${config.spinner} border-4 border-gray-200 border-t-primary100 border-r-primary100`} />
        ),
        pulse: (
            <div className={`${config.spinner} bg-primary100 rounded-full animate-pulse opacity-75`} />
        ),
        dots: (
            <div className="flex space-x-2">
                <div className="w-3 h-3 bg-primary100 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                <div className="w-3 h-3 bg-primary100 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                <div className="w-3 h-3 bg-primary100 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
            </div>
        ),
        heartbeat: (
            <div className="flex flex-col items-center space-y-3">
                <FaHeartbeat className={`text-primary100 ${config.heartbeat} animate-pulse`} />
                <div className={`animate-spin rounded-full ${config.spinner} border-4 border-gray-200 border-t-primary100 border-r-primary100`} />
            </div>
        ),
        medical: (
            <div className="relative">
                <div className={`${config.spinner} border-4 border-gray-200 rounded-full`}>
                    <div className="absolute inset-0 border-4 border-transparent border-t-primary100 border-r-emerald-500 rounded-full animate-spin" />
                    <div className="absolute inset-2 border-2 border-transparent border-b-primary100 border-l-emerald-400 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }} />
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <FaHeartbeat className="text-primary100 text-lg animate-pulse" />
                </div>
            </div>
        )
    };

    const LoadingContent = () => (
        <div className={`flex flex-col items-center justify-center ${config.container} ${className}`}>
            {variants[variant]}
            {message && (
                <p className={`mt-4 text-gray-600 ${config.text} font-medium text-center animate-pulse`}>
                    {message}
                </p>
            )}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 bg-white bg-opacity-90 backdrop-blur-sm flex items-center justify-center z-50">
                <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm mx-4">
                    <LoadingContent />
                </div>
            </div>
        );
    }

    return (
        <div className="flex justify-center items-center">
            <LoadingContent />
        </div>
    );
}
